"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateInterval = validateInterval;

var _constants = require("../constants");

function validateInterval(interval) {
  if (typeof interval !== "undefined" && !Object.keys(_constants.IntervalMap).some(function (innerInterval) {
    return innerInterval === interval;
  })) {
    throw new Error("interval must be one of TimeSync.SECONDS, TimeSync.MINUTES, TimeSync.HOURS or TimeSync.DAYS");
  }
}